'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnterIconHelperSpan = exports.EnterIconSpan = exports.CrossIconSpan = exports.LoadingSpan = exports.BackIcon = exports.SearchIconSpan = exports.StyledAutoSuggest = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  .react-autosuggest__suggestions-list {\n    margin: 0;\n  }\n\n  input {\n    position: relative;\n  }\n'], ['\n  .react-autosuggest__suggestions-list {\n    margin: 0;\n  }\n\n  input {\n    position: relative;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 28%;\n  left: 17px;\n\n  ', '\n'], ['\n  position: absolute;\n  top: 28%;\n  left: 17px;\n\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: ', ';\n  '], ['\n    display: ', ';\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 28%;\n  left: 2.8%;\n  display: none;\n\n  ', '\n'], ['\n  position: absolute;\n  top: 28%;\n  left: 2.8%;\n  display: none;\n\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  right: 170px;\n  ', '\n'], ['\n  position: absolute;\n  top: 50%;\n  right: 170px;\n  ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    right: 28%;\n  '], ['\n    right: 28%;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 30%;\n  right: 135px;\n  cursor:pointer;\n  ', '\n'], ['\n  position: absolute;\n  top: 30%;\n  right: 135px;\n  cursor:pointer;\n  ', '\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    right: 20px;\n  '], ['\n    right: 20px;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0%;\n  right: 60px;\n\n  ', '\n'], ['\n  position: absolute;\n  top: 0%;\n  right: 60px;\n\n  ', '\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 30%;\n  right: 10px;\n  ', '\n'], ['\n  position: absolute;\n  top: 30%;\n  right: 10px;\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledAutoSuggest = exports.StyledAutoSuggest = _styledComponents2.default.div(_templateObject);

StyledAutoSuggest.displayName = 'StyledAutoSuggest';
var SearchIconSpan = exports.SearchIconSpan = _styledComponents2.default.span(_templateObject2, _helpers.media.mobileTablet(_templateObject3, function (props) {
  return props.showBack ? 'none' : 'inline-block';
}));

SearchIconSpan.displayName = 'SearchIconSpan';
var BackIcon = exports.BackIcon = _styledComponents2.default.span(_templateObject4, _helpers.media.mobileTablet(_templateObject3, function (props) {
  return props.showBack ? 'inline-block' : 'none';
}));

BackIcon.displayName = 'BackIcon';
var LoadingSpan = exports.LoadingSpan = _styledComponents2.default.span(_templateObject5, _helpers.media.mobileTablet(_templateObject6));

LoadingSpan.displayName = 'LoadingSpan';
var CrossIconSpan = exports.CrossIconSpan = _styledComponents2.default.span(_templateObject7, _helpers.media.mobileTablet(_templateObject8));

CrossIconSpan.displayName = 'CrossIconSpan';
var EnterIconSpan = exports.EnterIconSpan = _styledComponents2.default.span(_templateObject9, _helpers.media.mobileTablet(_templateObject10));

EnterIconSpan.displayName = 'EnterIconSpan';
var EnterIconHelperSpan = exports.EnterIconHelperSpan = _styledComponents2.default.span(_templateObject11, _helpers.media.mobileTablet(_templateObject10));
EnterIconHelperSpan.displayName = 'EnterIconHelperSpan';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-auto-complete-search-box/styles.js
// module id = 2883
// module chunks = 4